import { useLocation } from '@tanstack/react-router';
import { useMemo } from 'react';
import { ReactComponent as LiliLogo } from '@Assets/logos/lili-logo-adaptive.svg';
import { DesktopSideBarItem } from '@Components/happyFlowTemplate/desktopSideBar/DesktopSideBarItem.tsx';
import {
  getSideMenuItemsFromOnboardingFlowIdentifier,
  PAGES_TO_HIDE,
  useSidebarLogic,
} from '@Components/happyFlowTemplate/sidebarUtils.ts';
import { routesModel } from '@Router/router.consts.ts';
import { useBoundStore } from '@Store/index.ts';

export const DesktopSideBar = () => {
  const { pathname } = useLocation();
  const { onboardingFlowIdentifier } = useBoundStore.getState().onboardingSlice.getOnboardingData();
  const onboardingType = useBoundStore.getState().getOnboardingType();
  const menuItems = getSideMenuItemsFromOnboardingFlowIdentifier(
    onboardingFlowIdentifier,
    onboardingType
  );
  const hideDesktopSideBar = useMemo(() => {
    return PAGES_TO_HIDE.some((pageId) =>
      pathname.includes(routesModel[pageId as keyof typeof routesModel].path)
    );
  }, [pathname]);
  const { shouldShowItems, activeRouteIndex } = useSidebarLogic(pathname, menuItems);

  return hideDesktopSideBar ? null : (
    <div className='z-50 justify-center pt-[38px] min-w-[370px] w-[370px] xl:w-[400px] bg-surface-brand-action-05 border-r border-outline-primary-bw-03 h-full hidden sm:flex'>
      <div className='flex flex-col gap-[60px] w-[200px]'>
        <LiliLogo className='w-[70px] text-text-main-primary-inverse' />
        {shouldShowItems && (
          <ul className='flex flex-col'>
            {menuItems.map((item, index: number) => (
              <DesktopSideBarItem
                isActive={index === activeRouteIndex}
                isPrevious={index < activeRouteIndex}
                routeName={item.name}
                key={index}
              />
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};
